import React from 'react';
import styles from './ExternalLink.module.css';

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
}

/**
 * ExternalLink Component
 *
 * 외부 사이트로 연결되는 링크를 위한 컴포넌트
 * - 새 탭에서 열림 (target="_blank")
 * - 보안을 위한 rel="noopener noreferrer" 자동 적용
 * - 선택적 외부 링크 아이콘 표시
 *
 * 주의: 원본 사이트(keso.kr)로는 절대 연결하지 않습니다.
 * 한국승강기안전공단 등 제3자 파트너 사이트용입니다.
 */
const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  children,
  className = '',
  showIcon = false,
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${styles.externalLink} ${className}`}
      aria-label={`${children} (새 창에서 열림)`}
    >
      {children}
      {showIcon && <span className={styles.externalIcon}>↗</span>}
    </a>
  );
};

export default ExternalLink;
